import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import OnDemandWebinar from 'common/illustrations/OnDemandWebinar';

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.palette.grayscale.gray65};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
`;

const Illustration = styled(OnDemandWebinar)`
    max-width: 100%;
`;

const Message = styled.p`
    color: ${({ theme }) => theme.palette.grayscale.white};
    font-size: 1.375rem;
    font-weight: normal;
    line-height: 1.75rem;
    letter-spacing: 0;
    text-align: center;
    padding: 0 1rem;
`;

const GoldcastMessage = ({ message, shouldShowIllustration }) => (
    <Wrapper>
        {shouldShowIllustration ? <Illustration aria-hidden="true" /> : null}
        <Message>{message}</Message>
    </Wrapper>
);

GoldcastMessage.propTypes = {
    message: PropTypes.string.isRequired,
    shouldShowIllustration: PropTypes.bool,
};

GoldcastMessage.defaultProps = {
    shouldShowIllustration: false,
};

export default GoldcastMessage;
